'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _themeProvider = require('@spp/theme-provider');

var _UserMenuWidget = require('./UserMenuWidget');

var _UserMenuWidget2 = _interopRequireDefault(_UserMenuWidget);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-unused-vars */
var themedUserMenuWidget = (0, _themeProvider.themer)('@vg/cn-skin-vg/user-menu-widget')(_UserMenuWidget2.default);

exports.default = {
    UserMenuWidget: themedUserMenuWidget
};
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@vg/cn-skin-vg/lib/cjs/widgets/index.js
 ** module id = 715
 ** module chunks = 1
 **/